var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:[_vm.$style.container, 'column']},_vm._l((_vm.socialSharingLinks),function(link,index){return _c('li',{key:index},[_c('SocialSharingLink',{attrs:{"link":link}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }